import React from 'react';

import { useApiGet, useApiLoading } from 'react-reqq-lite';

import { GET_MERCHANT_PROFILE } from 'modules/merchant/profile/constant';

import * as actions from './actions';
import * as c from './constants';

export const useCreateMerchant = () => {
  const isApiLoading = useApiLoading(c.CREATE_MERCHANT, 'post');
  const create = React.useCallback((payload, callback) => {
    actions.createMerchant(payload, callback);
  }, []);

  return [isApiLoading, create];
};

export const useGetMerchantProfile = (defaultValue = {}) => {
  const isApiLoading = useApiLoading(GET_MERCHANT_PROFILE, 'get');
  const data = useApiGet(GET_MERCHANT_PROFILE, defaultValue);
  return [isApiLoading, data];
};

export const useUpdateMerchant = () => {
  const isApiLoading = useApiLoading(c.UPDATE_MERCHANT_PROFILE, 'put');
  const update = React.useCallback((merchant_uuid, payload, callback) => {
    actions.updateMerchantProfile(merchant_uuid, payload, callback);
  }, []);
  return [isApiLoading, update];
};
